import type { AttributeType, Metrics } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import type { GroupListModel } from '@aytm/app/insights/dashboard/models/types.ClientModel'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export type StateSelectorParams = {
  attributes: Record<string, AttributeType>
  dataMetrics: Record<string, Metrics[]>
  sections: GroupListModel
  trackTarget: string
  sortByAttribute: string | null
  sortByMethod: string | null
  sortOrderPositions: number[] | null
  chartAttribute: string | null
  chartMethod: string | null
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const dataMetrics = state.currentData?.dataMetrics || {}
  const attributes = state.currentData?.attributes || {}
  const sections = block?.getSections()
  const trackTarget = block?.get<string>('trackTarget') || 'entity'
  const sortByAttribute = block?.get<string>('sortByAttribute') || null
  const sortByMethod = staticStore.featureMultiMetrics ? block?.get<string>('sortByMethod') || null : null
  const sortOrderPositions: number[] = null
  const chartAttribute = block?.get<string>('chartAttribute') || null
  const chartMethod = staticStore.featureMultiMetrics ? block?.get<string>('chartMethod') || null : null
  return {
    dataMetrics,
    attributes,
    sections,
    trackTarget,
    sortByAttribute,
    sortByMethod,
    sortOrderPositions,
    chartAttribute,
    chartMethod
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : (!prev && Boolean(next)) ||
      (Boolean(prev) && !next) ||
      prev.attributes !== next.attributes ||
      prev.dataMetrics !== next.dataMetrics ||
      prev.sections !== next.sections ||
      prev.trackTarget !== next.trackTarget ||
      prev.sortByAttribute !== next.sortByAttribute ||
      prev.sortByMethod !== next.sortByMethod ||
      prev.chartAttribute !== next.chartAttribute ||
      prev.chartMethod !== next.chartMethod ||
      JSON.stringify(prev.sortOrderPositions) !== JSON.stringify(next.sortOrderPositions)
